import * as React from 'react'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {TaskData} from 'yougile-model'
import {StickerPanelProps} from '@components/sticker/sticker-panel/types'
import {useDragScrollable} from '@containers/drag-scrollable'
import {UserProxy} from '@extensions/proxies/user-proxy'
import {Help} from '../../common/help/help'
import {StickerPanel} from '../../sticker/sticker-panel'
import {ByUserColumn} from './by-user-column'

interface Props {
  emulated: StickerPanelProps['emulated']
  tasks: TaskData[]
  users: UserProxy[]
}

export const ByUserBase = (props: Props) => {
  const {tasks, users, emulated} = props
  const bem = Util.bemFrom('stats-timeline')
  const [ref, mouseDown] = useDragScrollable()

  return (
    <div className={bem()}>
      <div className={bem('top-cnt')}>
        <div className={bem('filter')}>
          <div className={bem('filter-label')}>{Lang.msg.filtration}:</div>
          <StickerPanel emulated={emulated} location="report" />
        </div>
        <Help name="byUserReport" />
      </div>
      <div className={bem('clear')} />

      <div className={bem('cnt')} onMouseDown={mouseDown} ref={ref}>
        {!tasks && <div className={bem('loading')} />}
        {!!tasks && <ByUserColumn user={undefined} tasks={tasks} />}
        {!!tasks &&
          users.map(u => (
            <ByUserColumn user={u} key={u.userId} tasks={tasks} />
          ))}
        <div className={bem('space')} />
      </div>
    </div>
  )
}
